import { SecondaryApiTypeMap } from '@tassat/common-definitions';
import { FirmSecondaryApiTypeRecord, UserSecondaryApiTypeRecord } from '@tassat/fred-definitions';

interface ApiCapabilitiesHelper {
    tokenApi: boolean;
    secondaryApiList?: FirmSecondaryApiTypeRecord[] | UserSecondaryApiTypeRecord[];
}

export const hasApiCapabilities = (
    { tokenApi, secondaryApiList }: ApiCapabilitiesHelper
) => tokenApi || (secondaryApiList && secondaryApiList.length > 0);

export const getApiCapailitiesListString = ({ tokenApi, secondaryApiList }: ApiCapabilitiesHelper) => {
    const apiCapabilities = [] as string[];
    if (tokenApi) {
        apiCapabilities.push('Token API');
    }

    if (secondaryApiList && secondaryApiList.length) {
        secondaryApiList
            .forEach((api) => {
                apiCapabilities.push(`${SecondaryApiTypeMap[api.APISecondaryConnectionType].displayValue}`);
            });
    }

    return apiCapabilities.join(', ');
};